(function () {
  var TARGET_MEDIA_ID = '44359963050228';

  function attachProgressBar(video, wrapper) {
    if (wrapper.querySelector('.sap-video-progress')) return;

    var bar = document.createElement('div');
    bar.className = 'sap-video-progress';
    var fill = document.createElement('div');
    fill.className = 'sap-video-progress__fill';
    bar.appendChild(fill);
    wrapper.appendChild(bar);

    video.addEventListener('timeupdate', function () {
      if (video.duration) {
        fill.style.width = (video.currentTime / video.duration) * 100 + '%';
      }
    });
  }

  function scan() {
    document
      .querySelectorAll('[data-media-id="' + TARGET_MEDIA_ID + '"]')
      .forEach(function (wrapper) {
        var video = wrapper.querySelector('video');
        if (video) attachProgressBar(video, wrapper);
      });
  }

  function init() {
    scan();
    var observer = new MutationObserver(scan);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
